import React, { useContext, useEffect, useRef, useState } from "react";
import axios from "axios";
import { createPortal } from "react-dom";
import BubbleImportFunction from "../../temple/templegridroom/BubblesJSONcommandPanel.json/BubbleImportFunction";
import { AuthContext } from "../../context/App-Context";
import BubbleDisplayImg from "../../temple/templegridroom/Flex/TgridEditorForm/bubblesDisplay/BubbleDisplayImg";

const OcancerzStarszPostItems = (props) => {
  const [data, setData] = useState(null);
  const [dataForBubbles, setDataForBubbles] = useState(null);
  const [StarPostImages, setpostPhotos] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const BUBBLE_KIT_MAP = {
    HUM1: "human",
    HOM2: "home",
    GEO3: "geo",
    FIR4: "fireworks",
    P3D5: "portrait3d",
    TRP6: "portraittrap",
    AFR7: "portraitafrica",
    AFZ8: "portraitafricazone",
    AFW9: "africawesttrap",
    AFS0: "africasouthtrap",
    LTK1: "letterkit",
    LHK2: "letterhebrewkit",
    LHT3: "letterhebrewtextkit",
    LGT4: "lettergreektextkit",
    WDK1: "wordkindkit",
    WDH2: "wordhidekit",
    WDA3: "wordanimalkit",
    WKC4: "wordkindcontourkit",
    WNC5: "wordnocontourkit",
    WAC6: "wordanimalcontourkit",
    CTK7: "customtextcontourkit",
    ROD1: "road",
    CAR1: "car",
    CUB1: "carcube",
    CBT2: "carcubetilt",
    CBS3: "carcubesegment",
    CBF4: "carcubefused",
    CBA5: "carcubealign",
    AUR1: "aura",
    RDO1: "radarone",
    RDT2: "radartwo",
    GUA1: "guardian",
    GHO1: "ghost",
    HPR1: "humanpresence",
    RBW1: "starspirit",
    SPW1: "cosm",
  };

  const STAR_TRAIL_KITS = ["starspirit"];

  const [previewPhoto, setPreviewPhoto] = useState(null);
  const [previewIndex, setPreviewIndex] = useState(null);
  const modalScrollRef = useRef(null);

  useEffect(() => {
    if (previewIndex !== null && modalScrollRef.current) {
      setTimeout(() => {
        if (modalScrollRef.current) {
          modalScrollRef.current.scrollLeft =
            modalScrollRef.current.clientWidth * previewIndex;
        }
      }, 10);
    }
  }, [previewIndex !== null]);

  const [selectedPreviewKit, setSelectedPreviewKit] = useState(null);

  const rawMyBubbles = dataForBubbles
    ? Array.isArray(dataForBubbles)
      ? dataForBubbles
      : [dataForBubbles]
    : [];

  // Ignore normal bubbles if in carousel
  const myBubbles = props.isPreviewMode
    ? rawMyBubbles.filter((b) => {
        const rawCode =
          b?.templeGridpostBubblesData?.activeKit ||
          b?.templeGridpostBubblesData?.hiddenCode ||
          b?.activeKitCode ||
          b?.activeKit;
        const resolvedName = BUBBLE_KIT_MAP[rawCode] || rawCode;
        return STAR_TRAIL_KITS.includes(resolvedName);
      })
    : rawMyBubbles;

  const inheritedBubbles = props.inheritedStarTrailBubbles || [];

  const combinedBubbles = [...inheritedBubbles, ...myBubbles].filter(
    (b) => b && Object.keys(b).length > 0
  );

  let defaultPreviewKit = "none";

  if (combinedBubbles.length > 0) {
    const firstBubble = combinedBubbles[0];
    const rawHiddenCode =
      firstBubble?.templeGridpostBubblesData?.activeKit ||
      firstBubble?.templeGridpostBubblesData?.hiddenCode ||
      firstBubble?.activeKitCode ||
      firstBubble?.activeKit;

    defaultPreviewKit =
      BUBBLE_KIT_MAP[rawHiddenCode] || rawHiddenCode || "none";
  }

  const prevInheritedRef = useRef(
    inheritedBubbles[0]?.templeGridpostBubblesData?.activeKit ||
      inheritedBubbles[0]?.activeKit
  );

  useEffect(() => {
    const newKit =
      inheritedBubbles[0]?.templeGridpostBubblesData?.activeKit ||
      inheritedBubbles[0]?.activeKit;
    const resolvedNewKit = BUBBLE_KIT_MAP[newKit] || newKit;

    if (prevInheritedRef.current !== resolvedNewKit) {
      setSelectedPreviewKit(null);
      prevInheritedRef.current = resolvedNewKit;
    }
  }, [inheritedBubbles]);

  const activePreviewKit =
    selectedPreviewKit !== null ? selectedPreviewKit : defaultPreviewKit;

  const formatShortTime = (timeStr) => {
    if (!timeStr) return "";
    return timeStr
      .replace(/, \d{4}/, "")
      .replace(/\s*[a-z]{3}$/i, "")
      .trim();
  };

  const auth = useContext(AuthContext);

  const postId =
    typeof props.postFunction === "object"
      ? props.postFunction.uid || props.postFunction._id
      : props.postFunction;

  const handleBubblesClick = () => {
    if (props.onEditPost && data) {
      props.onEditPost({
        uid: postId,
        postText: data.ocancerzText,
        postDate: data.postDate,
        postImages: StarPostImages,
        starsinConstellation: [],
        postType: "star",
      });
    }
  };

  // 🌟 NEW: Prevents infinite reloading
  const isFetched = useRef(false);

  useEffect(() => {
    if (
      !postId ||
      (isFetched.current && props.refreshFeedBubbles === undefined)
    )
      return;

    let isMounted = true;
    setLoading(true);

    const fetchAllData = async () => {
      try {
        const [imagesResponse, postResponse] = await Promise.all([
          axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/ocancerz-metavz/getImagesOcancerzStarPost?username=${auth.loginVar}&uid=${postId}`
          ),
          axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/ocancerz-metavz/getOcancerzStarPost/${auth.loginVar}/${postId}`
          ),
        ]);

        if (!isMounted) return;

        setpostPhotos(imagesResponse.data.data.functionGo);
        const postData = postResponse.data.functionGO;
        setData(postData);

        let bubbleIdToFetch = null;
        if (postData && postData.postBubbles) {
          bubbleIdToFetch = Array.isArray(postData.postBubbles)
            ? postData.postBubbles[0]
            : postData.postBubbles;
        }

        if (
          bubbleIdToFetch &&
          typeof bubbleIdToFetch === "string" &&
          bubbleIdToFetch.trim() !== ""
        ) {
          const bubblesResponse = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/ocancerz-metavz/getOcancerzStarPostBubbles/${bubbleIdToFetch}`
          );
          if (isMounted)
            setDataForBubbles(bubblesResponse.data.data.functionGo);
        } else {
          if (isMounted) setDataForBubbles(null);
        }

        isFetched.current = true;
      } catch (err) {
        if (isMounted) setError(err);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchAllData();
    return () => {
      isMounted = false;
    };
  }, [auth.loginVar, postId, props.refreshFeedBubbles]);
  useEffect(() => {
    let bubbleIdToFetch = null;
    if (data && data.postBubbles) {
      bubbleIdToFetch = Array.isArray(data.postBubbles)
        ? data.postBubbles[0]
        : data.postBubbles;
    }

    if (
      bubbleIdToFetch &&
      typeof bubbleIdToFetch === "string" &&
      bubbleIdToFetch.trim() !== ""
    ) {
      const fetchData = async () => {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/ocancerz-metavz/getOcancerzStarPostBubbles/${bubbleIdToFetch}`
          );
          setDataForBubbles(response.data.data.functionGo);
        } catch (err) {
        } finally {
          setLoading(false);
        }
      };
      fetchData();
    } else {
      setDataForBubbles(null);
    }
  }, [auth.loginVar, data, props.refreshFeedBubbles]);

  return (
    <div>
      <style>{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
      {/* The Fullscreen Modal Overlay (Escaped via createPortal) */}
      {previewIndex !== null &&
        createPortal(
          <div
            className="photo-preview-modal"
            onClick={() => setPreviewIndex(null)}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(255, 255, 255, 0.95)",
              zIndex: 99999,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <button
              className="close-preview-btn"
              onClick={() => setPreviewIndex(null)}
              style={{
                position: "absolute",
                top: "20px",
                right: "30px",
                background: "none",
                color: "#00008b",
                border: "none",
                fontSize: "50px",
                cursor: "pointer",
                zIndex: 100000,
                fontWeight: "100",
                lineHeight: "0.5",
              }}
            >
              ×
            </button>

            {/* FLOATING BUBBLE TOGGLE MENU */}
            {combinedBubbles.length > 0 && (
              <div
                onClick={(e) => e.stopPropagation()}
                style={{
                  position: "absolute",
                  bottom: "30px",
                  right: "30px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  zIndex: 100000,
                }}
              >
                {combinedBubbles
                  .filter((bubbleItem, index, self) => {
                    const getCode = (b) =>
                      b?.templeGridpostBubblesData?.hiddenCode ||
                      b?.hiddenCode ||
                      b?.templeGridpostBubblesData?.activeKit ||
                      b?.activeKit;
                    const code = getCode(bubbleItem);
                    return index === self.findIndex((t) => getCode(t) === code);
                  })
                  .map((bubbleItem, index) => {
                    const rawCode =
                      bubbleItem?.templeGridpostBubblesData?.activeKit ||
                      bubbleItem?.activeKitCode ||
                      bubbleItem?.activeKit ||
                      bubbleItem?.hiddenCode;

                    const kitName =
                      BUBBLE_KIT_MAP[rawCode] || rawCode || "none";
                    const isCurrentlyActive = activePreviewKit === kitName;
                    const label =
                      kitName === "none" ? "NONE" : kitName.toUpperCase();

                    return (
                      <button
                        key={bubbleItem.uid || index}
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedPreviewKit(
                            isCurrentlyActive ? "none" : kitName
                          );
                        }}
                        style={{
                          background: isCurrentlyActive ? "#00008b" : "#ffffff",
                          color: isCurrentlyActive ? "#ffffff" : "#00008b",
                          border: "2px solid #00008b",
                          borderRadius: "20px",
                          padding: "8px 16px",
                          fontWeight: "bold",
                          fontFamily: "monospace",
                          cursor: "pointer",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                          transition: "all 0.2s ease",
                        }}
                      >
                        ⚡ {label}
                      </button>
                    );
                  })}
              </div>
            )}

            {/* THE SWIPEABLE MODAL CAROUSEL */}
            <div
              ref={modalScrollRef}
              className="hide-scrollbar"
              style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "nowrap",
                overflowX: "auto",
                overflowY: "hidden",
                scrollSnapType: "x mandatory",
                WebkitOverflowScrolling: "touch",
                width: "100vw",
                height: "100vh",
              }}
            >
              {StarPostImages.map((photo, index) => {
                const imgSrc =
                  photo.url ||
                  photo.src ||
                  (typeof photo === "string" ? photo : "");
                const imgTime =
                  photo.time ||
                  photo.timestamp ||
                  (data?.imageTimestamps ? data.imageTimestamps[index] : null);

                return (
                  <div
                    key={`modal-${index}`}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      flex: "0 0 100vw",
                      width: "100vw",
                      height: "100vh",
                      scrollSnapAlign: "start",
                    }}
                  >
                    <div
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        width: "95%",
                        maxWidth: "800px",
                        height: "80vh",
                        position: "relative",
                      }}
                    >
                      <BubbleDisplayImg
                        src={imgSrc}
                        activeKit={activePreviewKit}
                        showOcancer={false}
                      />
                      {imgTime && (
                        <div
                          style={{
                            textAlign: "center",
                            marginTop: "15px",
                            color: "#00008b",
                            fontWeight: "bold",
                          }}
                        >
                          {formatShortTime(imgTime)}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>,
          document.body
        )}

      {data && (
        <div style={{ width: "100%", minWidth: 0, boxSizing: "border-box" }}>
          <article
            key={data.uid}
            className="post-card"
            style={{
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
              boxSizing: "border-box",
              overflow: "hidden",
              background: "#fdfdfd",
              border: "1px solid #eaeaea",
              borderRadius: "8px",
              padding: "12px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              className="post-header"
              style={{
                display: "flex",
                gap: "8px",
                alignItems: "center",
                flexWrap: "wrap",
                marginBottom: "8px",
              }}
            >
              <span className="avatar">👑</span>
              <span
                className="username"
                style={{ fontWeight: "bold", wordBreak: "break-all" }}
              >
                {auth.loginVar}
              </span>
              <span
                className="timestamp"
                style={{ fontSize: "0.8rem", color: "#888" }}
              >
                {data.postDate}
              </span>
            </div>

            <p
              className="post-text"
              style={{
                wordBreak: "break-word",
                overflowWrap: "break-word",
                whiteSpace: "pre-wrap",
                margin: "0 0 12px 0",
                fontSize: "0.9rem",
              }}
            >
              {data.ocancerzText}
            </p>

            {StarPostImages && (
              <div style={{ width: "100%", maxWidth: "100%", minWidth: 0 }}>
                <div
                  className="hide-scrollbar"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "nowrap",
                    overflowX: "auto",
                    gap: "12px",
                    paddingBottom: "12px",
                    scrollSnapType: "x mandatory",
                    WebkitOverflowScrolling: "touch",
                    width: "100%",
                  }}
                >
                  {StarPostImages.map((photo, index) => {
                    const imgSrc =
                      photo.url ||
                      photo.src ||
                      (typeof photo === "string" ? photo : "");
                    const imgTime =
                      photo.time ||
                      photo.timestamp ||
                      (data?.imageTimestamps
                        ? data.imageTimestamps[index]
                        : null);

                    return (
                      <div
                        key={photo.key || photo.filename || `photo-${index}`}
                        role="button"
                        tabIndex={0}
                        onClick={() => {
                          setPreviewIndex(index);
                          setSelectedPreviewKit(null);
                        }}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          flex: "0 0 100%",
                          maxWidth: "100%",
                          scrollSnapAlign: "center",
                          cursor: "pointer",
                        }}
                      >
                        <div
                          className="photo-item"
                          style={{
                            margin: 0,
                            width: "100%",
                            height: "260px",
                            maxHeight: "260px",
                            aspectRatio: "auto",
                            boxShadow: "none",
                            transform: "none",
                            backgroundColor: "transparent",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                            borderRadius: "6px",
                          }}
                        >
                          <BubbleDisplayImg
                            src={imgSrc}
                            alt={photo.filename || `Photo ${index + 1}`}
                            activeKit={activePreviewKit}
                            showOcancer={false}
                          />
                        </div>

                        {imgTime && (
                          <div
                            style={{
                              marginTop: "8px",
                              textAlign: "left",
                              paddingLeft: "4px",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "12px",
                                color: "#007bff",
                                fontWeight: "bold",
                              }}
                            >
                              {formatShortTime(imgTime)}
                            </span>
                          </div>
                        )}
                        {photo.caption && (
                          <div
                            className="photo-caption"
                            style={{ textAlign: "left", marginTop: "4px" }}
                          >
                            {photo.caption}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            <div className="post-footer">
              {!props.isPreviewMode && combinedBubbles.length > 0 && (
                <div
                  className="active-bubbles-display"
                  style={{
                    marginTop: "12px",
                    paddingTop: "12px",
                    borderTop: "1px solid #00008b",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "6px",
                  }}
                >
                  {combinedBubbles
                    .filter((bubbleItem, index, self) => {
                      const getCode = (b) =>
                        b?.templeGridpostBubblesData?.hiddenCode ||
                        b?.hiddenCode ||
                        b?.templeGridpostBubblesData?.activeKit ||
                        b?.activeKit;
                      const code = getCode(bubbleItem);
                      return (
                        index === self.findIndex((t) => getCode(t) === code)
                      );
                    })
                    .filter((bubbleItem) => {
                      const kitCode =
                        bubbleItem?.templeGridpostBubblesData?.activeKit ||
                        bubbleItem?.activeKit;
                      return !STAR_TRAIL_KITS.includes(kitCode);
                    })
                    .map((bubbleItem, index) => (
                      <div key={index}>
                        <BubbleImportFunction
                          showBubbles={
                            bubbleItem?.templeGridpostBubblesData?.activeKit ||
                            bubbleItem?.activeKit
                          }
                          showCode={
                            bubbleItem?.templeGridpostBubblesData?.hiddenCode ||
                            bubbleItem?.hiddenCode
                          }
                        />
                      </div>
                    ))}
                </div>
              )}
            </div>

            {!props.isPreviewMode && props.onMergeClick && (
              <button
                onClick={() => props.onMergeClick(postId)}
                style={{
                  width: "100%",
                  padding: "8px",
                  background: "#7b00ff",
                  color: "white",
                  border: "none",
                  borderRadius: "6px",
                  marginTop: "8px",
                  cursor: "pointer",
                  fontWeight: "bold",
                }}
              >
                + Merge Star
              </button>
            )}

            <div
              className="bubbles-area"
              onClick={handleBubblesClick}
              style={{
                cursor: "pointer",
                padding: "8px",
                background: "#f0f0f0",
                borderRadius: "6px",
                marginTop: "8px",
              }}
            >
              Bubbles <span style={{ fontSize: "1.2em" }}>+</span>
            </div>
          </article>
        </div>
      )}
    </div>
  );
};

export default React.memo(OcancerzStarszPostItems);
